export default {"src":"/_next/static/media/img_linkedin_4_1.7760bad5.svg","height":1087,"width":1440,"blurWidth":0,"blurHeight":0};